import React, { Component } from 'react'
import { Col, Row } from 'reactstrap'
import loader from './turkey_walk.gif'


export default class Loader extends Component {

    render() {
        return <Row>
            <Col className="text-center">
                <img src={loader} alt="loading..." />
            </Col>
        </Row>
    }
}